import { ClinicianManagementContent } from "@/features/admin/components/ClinicianManagementContent";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/clinicians")({
    component: CliniciansUsersPage,
});

function CliniciansUsersPage() {
    return (
        <>
            <ClinicianManagementContent />
            <Outlet />
        </>
    );
}
